import SharedDialog from './shared-dialog';
import { Dispatch, SetStateAction, useState } from 'react';
import { useUserSettings } from '../utils/use-user-settings';

import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

interface ChangeLogDialogProps {
  open: boolean;
  handleClose: () => void;
  changeLogMessage: string;
  setChangeLogMessage: Dispatch<SetStateAction<string>>;
  mutate: () => void;
  mutateLoading: boolean;
}

export default function ChangeLogDialog({
  open,
  handleClose,
  changeLogMessage,
  setChangeLogMessage,
  mutate,
  mutateLoading,
}: ChangeLogDialogProps) {
  const [hasError, setHasError] = useState(false);
  const { changeLogLength } = useUserSettings();

  function handleSubmit() {
    if (changeLogMessage.length < changeLogLength) {
      setHasError(true);
    } else {
      mutate();
    }
  }

  return (
    <SharedDialog
      open={open}
      handleClose={() => {
        setChangeLogMessage('');
        setHasError(false);
        handleClose();
      }}
      title={'Change Log Reason'}
      dialogContent={
        <Stack sx={{ minHeight: 150 }} gap={2}>
          <Typography>
            This action requires a reason, please provide one:
          </Typography>
          <TextField
            autoFocus
            id="changeLog"
            slotProps={{
              htmlInput: {
                minLength: changeLogLength,
              },
            }}
            error={hasError}
            helperText={`${changeLogMessage.length}/${changeLogLength}`}
            label="Reason"
            fullWidth
            autoComplete="off"
            multiline
            rows={3}
            value={changeLogMessage}
            onChange={(event) => setChangeLogMessage(event.target.value)}
          />
        </Stack>
      }
      primaryButton={{
        loading: mutateLoading,
        action: handleSubmit,
        disabled: mutateLoading || changeLogMessage.length < changeLogLength,
        title: 'Confirm',
      }}
    />
  );
}
